// extracted by mini-css-extract-plugin
export default {"ServiceMain":"ServiceMain_ServiceMain__htVwV","Ext":"ServiceMain_Ext__s5mrF"};